import React, { useState,useEffect,lazy,Suspense } from 'react';
import PeriodSlider from '../../components/GlobalComponents/PeriodSlider/PeriodSlider';
import { useSelector } from 'react-redux';
import { useGetPriodById } from '../../components/Login/Hooks/Index';
import InviteUser from './Copmonents/InviteUser/InviteUser';
import CircularProgress from '@mui/material/CircularProgress';
import {Grid,Box,Typography} from '@mui/material';
import Tabs from '@mui/material/Tabs';
import { useMediaQuery, useTheme } from '@mui/material';
import Tab from '@mui/material/Tab';
import TenantInfo from './Copmonents/TenantInfo/TenantInfo';
import Teams from './Copmonents/Teams/Teams';
import TreeAllTeams from "../Reports/LComponent/TreeAllTeams/TreeAllTeams";
import { useGetAllObjectiveByPeriodId2, useGetPersonAndTeamCountByTenantId } from '../Reports/Hooks/index';


interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}




const User
 :React.FC=function(){
  const onSuccesss = (): void => {};

  const onFailed = (): void => {};
  const tenantId: string = useSelector(
    (state: any) => state.meetings.profileTenantId
  );
  const [teamCount, SetTeamCount] = useState<any>('');
  const [personCount, SetPersonCount] = useState<any>('');
  const {
    data: perData,
    isLoading: perLoading,
    isError: periodError,
    isFetched,
  }: any = useGetPriodById(tenantId, onSuccesss, onFailed);
  const onSuccesssGetAllObjectiveData = (data: any) => {
  };
  const{data:objetcideData2,isLoading:getObjectiveLoading2,refetch:getObjectivesAgain2}=useGetAllObjectiveByPeriodId2(tenantId,onSuccesssGetAllObjectiveData)
  const{data:objetcideData}=useGetPersonAndTeamCountByTenantId(tenantId);

  useEffect(() => {
    if (objetcideData) {
      SetPersonCount(objetcideData?.personCount);
      SetTeamCount(objetcideData?.teamCount);
    }
  }, [objetcideData]);

  const [value, setValue] = React.useState(0);
  function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box >
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }
  function a11yProps(index: number) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm')); // بررسی موبایل بودن

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };
  
  
  
  
  return (
    <>
      <Grid container   >
      <Grid item xs={12} md={12}  >

<Box sx={{ width: '100%' }}>
  <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
    <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
      <Tab 
        label={`پرسنل (${personCount})`} 
        {...a11yProps(0)} 
        style={{color:'black', fontWeight:'700'}} 
      />
         </Tabs>
  </Box>

  
  <CustomTabPanel value={value} index={0}>
    <Suspense fallback={<Box width={'100%'} pt={5} textAlign={'center'} py={5}  ><CircularProgress/></Box>}  >
  <InviteUser/>
    </Suspense>
  </CustomTabPanel>
</Box>
</Grid>
</Grid>
    </>
  )
}

export default User